import { Route, Routes, Navigate } from "react-router-dom";
import "./app.scss";
import HomeLayout from "./layout/homeLayout";
import Contact from "./pages/contact";
import Home from "./pages/home";
import Services from "./pages/services";
import Shop from "./pages/shop";
import StylistsPage from "./pages/stylists";
import Classes from "./pages/classes";
import ThankYou from "./pages/thankyou";
import Memberships from "./pages/memberships";
import NotFound from "./pages/NotFound";
function App() {
  return (
    <HomeLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/services"
          element={<Navigate to="/services/extensions" replace />}
        />
        <Route path="/services/memberships" element={<Navigate to="/memberships" replace />} />
        <Route path="/services/:category" element={<Services />} />
        <Route path="/stylists" element={<StylistsPage />} />
        <Route path="/memberships" element={<Memberships />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/classes" element={<Classes />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HomeLayout>
  );
}

export default App;
